import React, { useContext } from "react";
import { ErrorBoundary, LoadingDots, Page, Tabs } from "@sscs/ui";
import { Link, Navigate, Outlet, useLocation, useOutletContext, } from "react-router";
import { REPORT_PAGES_ROUTES } from "../../constants";
import { ReportContext } from "../context";
import { useGetDiffSummaryQuery } from "../services/diff.api";
import { useGetReportSummaryQuery } from "../services/shared.api";
import ReproCheckHeader from "./header/ReproCheckHeader";
const TAB_ROUTES = [
    REPORT_PAGES_ROUTES.REPRODUCIBILITY_ISSUES,
    REPORT_PAGES_ROUTES.REPRODUCIBILITY_CHANGES,
    REPORT_PAGES_ROUTES.REPRODUCIBILITY_MODIFIED_FILES,
];
export const useReproducibilityContext = () => useOutletContext();
export const ReproducibilityIndex = () => {
    const { hasIssues } = useReproducibilityContext();
    const { search } = useLocation();
    return (React.createElement(Navigate, { to: {
            pathname: hasIssues
                ? REPORT_PAGES_ROUTES.REPRODUCIBILITY_ISSUES
                : REPORT_PAGES_ROUTES.REPRODUCIBILITY_CHANGES,
            search,
        }, relative: "path", replace: true }));
};
const Reproducibility = () => {
    var _a;
    var _b, _c;
    const { reportId, diffId, selectedCheck } = useContext(ReportContext);
    const { pathname, search } = useLocation();
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const { data: diffSummaryData } = useGetDiffSummaryQuery({
        ui_id: diffId,
    });
    const scanReport = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.checks_report.report.scans[selectedCheck];
    if (!reportSummaryData || !diffSummaryData || !scanReport)
        return React.createElement(LoadingDots, null);
    const reproCheckFailedCount = (_b = reportSummaryData.counters.reproducible_build) !== null && _b !== void 0 ? _b : 0;
    const modifiedFilesCount = (_c = (_a = reportSummaryData.counters.diff) === null || _a === void 0 ? void 0 : _a.total_changes) !== null && _c !== void 0 ? _c : 0;
    const hasIssues = diffSummaryData.issues.length > 0;
    const lastSegment = pathname.split("/").pop();
    const defaultTab = hasIssues
        ? REPORT_PAGES_ROUTES.REPRODUCIBILITY_ISSUES
        : REPORT_PAGES_ROUTES.REPRODUCIBILITY_CHANGES;
    const activeTab = lastSegment && TAB_ROUTES.includes(lastSegment) ? lastSegment : defaultTab;
    return (React.createElement(Page.Root, null,
        React.createElement(ErrorBoundary, { key: "repro-header" },
            React.createElement(ReproCheckHeader, { modifiedInfo: scanReport.artifact })),
        React.createElement(Page.Tabs, null,
            React.createElement(Tabs.Tabs, { value: activeTab },
                hasIssues ? (React.createElement(Tabs.Tab, { id: "repro-issues-tab", value: REPORT_PAGES_ROUTES.REPRODUCIBILITY_ISSUES, to: {
                        pathname: REPORT_PAGES_ROUTES.REPRODUCIBILITY_ISSUES,
                        search,
                    }, component: Link, label: "Issues", count: diffSummaryData.issues.length })) : null,
                React.createElement(Tabs.Tab, { id: "repro-changes-tab", value: REPORT_PAGES_ROUTES.REPRODUCIBILITY_CHANGES, to: {
                        pathname: REPORT_PAGES_ROUTES.REPRODUCIBILITY_CHANGES,
                        search,
                    }, component: Link, label: "Changes", count: reproCheckFailedCount }),
                React.createElement(Tabs.Tab, { id: "repro-modified-files-tab", value: REPORT_PAGES_ROUTES.REPRODUCIBILITY_MODIFIED_FILES, to: {
                        pathname: REPORT_PAGES_ROUTES.REPRODUCIBILITY_MODIFIED_FILES,
                        search,
                    }, component: Link, label: "Modified files", count: modifiedFilesCount }))),
        React.createElement(Outlet, { context: {
                issues: diffSummaryData.issues,
                hasIssues,
                reproCheckFailedCount,
            } })));
};
export default Reproducibility;
//# sourceMappingURL=Reproducibility.js.map